import { useState } from 'react';

export const useActiveScreen = index => {
	const [activePageIndex, setActivePageIndex] = useState(index);

	return {
		activePageIndex,
		setActivePageIndex,
	};
};
